// domain / caso de uso

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

// typings
import {
  IAtualizarUsuarioClienteClienteResponse,
  IAtualizarUsuarioClientePayload,
} from "@/hooks/usuários/atualizar-usuario-do-cliente/index.d";

// store / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleAtualizarUsuarioCliente } from "@/domain/use-cases/cutomers";

// toast helper
const notifySuccess = (message: string) =>
  toast(message, {
    type: "success",
    position: "top-center",
  });

const notifyError = (message: string) =>
  toast(message, {
    type: "error",
    position: "top-center",
  });

// novo tipo de input
type IDataApi = {
  user_id: number;
  payload: IAtualizarUsuarioClientePayload;
};

export function useAtualizarUsuarioCliente() {
  const queryClient = useQueryClient();
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<
    IAtualizarUsuarioClienteClienteResponse, // retorno
    Error, // erro
    IDataApi // entrada
  >({
    mutationFn: async ({ user_id, payload }: IDataApi) => {
      return await handleAtualizarUsuarioCliente(token!, user_id, payload);
    },
    onSuccess: async () => {
      notifySuccess("Usuário atualizado com sucesso!");
      await queryClient.invalidateQueries({ queryKey: ["usuario-clientes"] });
    },
    onError: async () => {
      notifyError("Houve um error em atualizar usuário!");
    },
  });

  return {
    atualizarUsuarioCliente: mutation.mutate,
    atualizarUsuarioClienteAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
